import { create } from "zustand";

interface IFeedV2State {
  isV2Variant: boolean;
  isV2HeaderVisible: boolean;
  isV2HeaderEnabled: boolean;
  subredditName: string | undefined;
  isScrollHintVisible: boolean;
  snapFeedDisabled: boolean | null;
  isForceSnapFeed: boolean;

  setV2Variant: (isV2Variant: boolean) => void;
  setV2Header: (isV2HeaderEnabled: boolean) => void;
  setV2HeaderVisible: (isV2HeaderVisible: boolean) => void;
  setSubredditName: (subredditName?: string) => void;
  setScrollHintVisible: (scrollHintVisible: boolean) => void;
  setSnapFeedDisabled: (snapFeedDisabled: boolean) => void;
  setForceSnapFeed: (isForceSnapFeed: boolean) => void;
}

export const useFeedV2Store = create<IFeedV2State>(
  (set) => ({
    isV2Variant: false,
    isV2HeaderVisible: true,
    isV2HeaderEnabled: false,
    subredditName: undefined,
    isScrollHintVisible: false,
    snapFeedDisabled: false,
    isForceSnapFeed: false,

    setV2Variant: (isV2Variant: boolean) => set(() => ({ isV2Variant })),
    setV2Header: (isV2HeaderEnabled: boolean) => set(() => ({ isV2HeaderEnabled })),
    setV2HeaderVisible: (isV2HeaderVisible: boolean) => set(() => ({ isV2HeaderVisible })),
    setSubredditName: (subredditName?: string) => set(() => ({ subredditName })),
    setScrollHintVisible: (isScrollHintVisible: boolean) => set(() => ({ isScrollHintVisible })),
    setSnapFeedDisabled: (snapFeedDisabled: boolean) => set(() => ({ snapFeedDisabled })),
    setForceSnapFeed: (isForceSnapFeed: boolean) => set(() => ({ isForceSnapFeed })),
  }),
);
